import { Trans } from '@lingui/react/macro'
import { Anchor, Card, Stack, Text } from '@mantine/core'
import { Link } from '@tanstack/react-router'

export function CostsHelpCard() {
  return (
    <Card withBorder radius="lg" p="md" bg="gray.0">
      <Stack gap="xs">
        <Text size="sm" fw={500}>
          <Trans>Cost management</Trans>
        </Text>
        <Text size="sm" c="dimmed">
          <Trans>
            Add costs in the{' '}
            <Anchor to="/maintenance" size="sm" component={Link}>
              Maintenance log
            </Anchor>
          </Trans>
        </Text>
        <Text size="sm" c="dimmed">
          <Trans>
            You can also add costs directly on this page using the "Add" button
          </Trans>
        </Text>
        <Text size="sm" c="dimmed">
          <Trans>Budgeted costs are calculated from task estimates</Trans>
        </Text>
        <Text size="sm" c="dimmed">
          <Trans>
            Edit or delete costs by opening an individual maintenance entry
          </Trans>
        </Text>
      </Stack>
    </Card>
  )
}
